import ShokzMember from '@theme/shokz-member';

/**
 * @returns {{ referralId: string, referralName: string }}
 */
function getReferralParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    referralId: params.get('referral_id') || '',
    referralName: params.get('referral_name') || '',
  };
}

function buildValidTitle(referralName) {
  const name = referralName || 'Your friend';
  return `You've been invited by <span class="hub-not-joined__terms__invited-form-title-name" data-referral-name>${name}</span>`;
}

function initReferralSignup() {
  if (window.__referralSignupInitialized) return;
  window.__referralSignupInitialized = true;

  const wrapper = document.querySelector('[data-referral-wrapper]');
  if (!wrapper) return;

  const form = document.querySelector('[data-referral-form]');
  const verifyEl = wrapper.querySelector('[data-referral-verify]');
  const titleEl = wrapper.querySelector('[data-referral-title]');
  const inlineErrorEl = wrapper.querySelector('[data-referral-inline-error]');
  const submitButton = document.querySelector('[data-terms-submit]');

  const setReferralVerified = (value) => {
    if (!form) return;
    form.dataset.referralVerified = value ? 'true' : 'false';
  };

  const setSubmitReady = (enabled) => {
    if (submitButton) {
      submitButton.disabled = !enabled;
    }
  };

  const showValid = (referralName) => {
    wrapper.classList.remove('hidden');
    verifyEl?.classList.remove('hidden');
    if (titleEl) {
      titleEl.innerHTML = buildValidTitle(referralName);
    }
    inlineErrorEl?.classList.add('hidden');
    setReferralVerified(true);
    setSubmitReady(true);
  };

  const showInvalid = () => {
    wrapper.classList.remove('hidden');
    verifyEl?.classList.remove('hidden');
    if (titleEl) {
      titleEl.textContent = 'This referral link needs a refresh.';
    }
    inlineErrorEl?.classList.remove('hidden');
    setReferralVerified(false);
    setSubmitReady(true);
  };

  if (Shopify?.designMode) {
    showValid('');
    return;
  }

  form?.setAttribute('data-referral-verified', 'pending');
  setSubmitReady(false);

  const { referralId, referralName } = getReferralParams();

  if (!referralId) {
    showInvalid();
    return;
  }

  ShokzMember.verifyReferralWithRetry(referralId)
    .then((res) => {
      if (res?.code === 0) {
        showValid(referralName);
      } else {
        showInvalid();
      }
    })
    .catch((error) => {
      console.error('[referral-signup]: verifyReferralWithRetry error', error);
      showInvalid();
    });
}

initReferralSignup();
